module.exports = __webpack_public_path__ + "static/img/about_item03.4fb48fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/about_item03.png
// module id = 4H1S
// module chunks = 2